<template>
  <div class="charm-rank">
    <div class="month">月榜</div>
    <div class="top3-box">
      <div
        v-for="(item, index) of topList.slice(0, 3)"
        :key="item.userUuid"
        class="item"
        :class="`top${index + 1}`"
        @click="toPlayerDetail(item.userUuid)"
      >
        <img :src="$util.setImageSize(item.avatarUrl,100,100)" class="head-portrait" />
        <div class="user-name">{{ item.userNickname }}</div>
        <div class="user-level-wrap">
          <div
            class="userlevel-tag"
            v-if="item.userLevel"
            :class="`level-${item.userLevel}`"
          ></div>
        </div>
        <div class="score">{{ item.rankingScore }}</div>
      </div>
    </div>
    <div class="score-board-box-bg">
      <div class="score-board-box">
        <div
          class="item"
          v-for="(item, index) of list.slice(3, 10)"
          :key="item.userUuid"
          @click="toPlayerDetail(item.userUuid)"
        >
          <div class="left">
            <span class="index">{{ index + 4 }}</span>
            <img :src="$util.setImageSize(item.avatarUrl,100,100)" alt="排名頭像" class="head-portrait" />
            <div class="top">
              <div class="user-level-wrap">
                <div
                  class="userlevel-tag"
                  v-if="item.userLevel"
                  :class="`level-${item.userLevel}`"
                ></div>
              </div>
              <span class="user-name">{{ item.userNickname }}</span>
            </div>
          </div>
          <div class="right">
            <span class="scroe">{{ item.rankingScore }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getVoiceRoomRank } from '@/api/voice-room';

export default {
  name: 'CharmRank',
  props: {
    roomUid: {
      type: String
    }
  },
  data() {
    return {
      list: []
    };
  },
  watch: {
    roomUid: {
      handler: function(nVal) {
        if (nVal) {
          this.getList();
        }
      },
      immediate: true
    }
  },
  computed: {
    topList() {
      return this.list && this.list.length
        ? [this.list[1] || {}, this.list[0] || {}, this.list[2] || {}]
        : [];
    }
  },
  methods: {
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    async getList() {
      const { data } = await getVoiceRoomRank({
        pageIndex: 1,
        pageSize: 10,
        rankingType: 1,
        roomUid: this.roomUid,
        type: 3 //月榜
      });
      this.list = data;
    }
  }
};
</script>
<style lang="scss" scoped>
.charm-rank {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.score-board-box-bg {
  height: 1px;
  flex: auto;
  .score-board-box {
    height: 100%;
  }
}
.month {
  position: absolute;
  padding: 2px 8px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.1);
  top: 0;
  right: 20px;
  font-size: 12px;
}
.top3-box {
  display: flex;
  background-image: url('../../images/rank-bg.png');
  background-size: 100% auto;
  padding: 25px 16px 0 18px;
  height: 192px;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    // border: 1px solid black;
    line-height: 1.4;

    .head-portrait {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      object-fit: cover;
      margin-bottom: 17px;
    }
    .user-name {
      font-size: 14px;
      width: 100%;
      @include ellipsis;
      text-align: center;
    }
    .score {
      font-size: 12px;
      @include ellipsis;
      text-align: center;
      color: #efdf8d;
    }
    &.top1 {
      width: 94px;
      .head-portrait {
        width: 48px;
        height: 48px;
        margin-top: 43px;
        margin-left: 6px;
      }
    }
    &.top2 {
      width: 107px;
      .head-portrait {
        width: 55px;
        height: 55px;
        margin-top: 18px;
        margin-bottom: 24px;
      }
    }
    &.top3 {
      width: 97px;
      .head-portrait {
        width: 46px;
        height: 46px;
        margin-top: 43px;
        margin-left: -5px;
      }
    }
  }
}
.user-level-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.userlevel-tag {
  height: 18px;
  width: 40px;
  margin-right: 6px;
}
.score-board-box-bg {
  background-color: #29282c;
}
.score-board-box {
  border-radius: 20px 20px 0px 0px;
  background: #1a1828;
  padding-top: 32px;
  overflow: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
  .item {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    justify-content: space-between;
  }

  .left {
    display: flex;
    align-items: center;
    .index {
      margin-right: 16px;
      color: #464692;
    }
    .head-portrait {
      width: 46px;
      height: 46px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 11px;
    }
    .user-name {
      font-size: 14px;
    }
  }
  .scroe {
    font-size: 14px;
    color: #de1ae2;
  }
}
</style>
